module.exports = __webpack_public_path__ + "static/img/round.a36968d6.png";